module.exports = __webpack_public_path__ + "img/csharp.0e18550b.png";